<template>
  <div class="elastic-block__wrap-select-btn">
    <a-popover trigger="click" placement="right">
      <a-button
        v-if="config"
        class="ant-btn-download elastic-block__toggle-btn"
        size="large"
        @click="showHelperBtnExports = !showHelperBtnExports"
      >
        <a-icon
          v-if="config.data.customprops.downloadReportButton.icon"
          :type="config.data.customprops.downloadReportButton.icon"
        />
        {{ btnText }}
      </a-button>

      <template #content>
        <div class="elastic-block__list-exports">
          <a-button
            v-for="(btn, i) in btns"
            :key="i"
            class="elastic-block__btn-export"
            @click="downloadReport(btn.format)"
          >
            {{ btn.label }}
          </a-button>
        </div>
      </template>
    </a-popover>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import moment from 'moment';
import store from "@/store";

const statusDict = {
  'error': 'Ошибка',
  'complete': 'Успешно',
  'success': 'Успешно'
}

export default {
  name: 'BtnExport',

  props: {
    btnText: {
      type: String,
      default: '',
      require: true,
    },
    filename: {
      type: String,
      default: '',
      require: false,
    },
    config: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    btns: {
      type: Array,
      require: false,
      default: () => {
        return [
          { label: 'Текущая страница XLSX', format: 'xlsx' },
          { label: 'Все данные CSV', format: 'csv' },
        ]
      },
    }
  },

  data() {
    return {
      showHelperBtnExports: false,
      documentData: [],
    };
  },
  methods: {
    downloadReport(format) {
      this.showHelperBtnExports = false;
      this.documentData = [];

      this.addHeaders();
      format === 'csv' ? this.$emit('downloadCsv') : this.createExel(format);
    },
    addHeaders() {
      if (this.columns.length) {
        const headers = [];
        this.columns.forEach((el)=>{
          el.title = el?.title || el?.name
          el.dataIndex = el.dataIndex || el.field
        })
        Object.keys(this.columns).forEach((key) => headers.push([this.columns[key].title]));
        this.documentData.push(headers);
      } else {
        const headers = [];

        Object.keys(this.fields).forEach((key) => headers.push([this.fields[key]?.name]));
        this.documentData.push(headers);
      }
    },
    createExel(format) {
      if (this.columns.length) {
        Object.keys(this.data).forEach((key) => {
          if (this.data[key]._source) {
            const res = [];
            Object.keys(this.columns).forEach((keyColumn) => {
              let value = this.data[key]._source[this.columns[keyColumn]?.dataIndex]
              if (value && typeof(value)==='object'){
                if (value.length) {
                  Object.keys(value).forEach(key1 => {
                    if (value[key1].hasOwnProperty('title') && value[key1].hasOwnProperty('value')) {
                      value[key1] = value[key1].title
                    }
                  })
                }
                if (value.hasOwnProperty('title') && value.hasOwnProperty('value')) {
                  value = value.title
                }
                value = JSON.stringify(value)
              }
              res.push([value])
            }
            );
            this.documentData.push(res);
          } else if (this.data[key].items) {
            const dateQuestion = this.data[key]?.date;
            const items = this.data[key]?.items;

            Object.keys(items).forEach((key2) => {
              const item = items[key2]
              const res = [];
              res.push([dateQuestion]);
              res.push([item?.translate_name]);
              res.push([statusDict[item?.status] || item?.status]);
              res.push([
                +item?.date1 ? moment.unix(item?.date1).format('YYYY-MM-DD HH:mm:ss') : ' ',
              ]);
              res.push([
                +item.date2 ? moment.unix(item?.date2).format('YYYY-MM-DD HH:mm:ss') : ' ',
              ]);
              if (item?.info){
                Object.keys(item.info).forEach((key3)=>{
                  let res1 = res.slice(0)
                  res1.push([key3])
                  res1.push([item.info[key3]])
                  this.documentData.push(res1)
                })
              }
              else {
                this.documentData.push(res)
              }
            });
          } else {
            //Кнопка подробнее для журнала машинного обучения
            let col1;
            let col2;
            let col3;
            let col4;
            let col5;
            Object.keys(this.data).forEach((key1) => {
              const val = this.data[key1];
              col1 = val.value.name;
              Object.keys(val.value.info).forEach((key2) => {
                const val2 = val.value.info[key2];
                col2 = key2;
                if (Object.keys(val2)) {
                  Object.keys(val2).forEach((key3) => {
                    col3 = key3;
                    const val3 = val2[key3]?.data;
                    if (val3 && Object.keys(val3)) {
                      Object.keys(val3).forEach((key4) => {
                        col4 = key4;
                        col5 = val3[key4];
                        this.documentData.push([[col1], [col2], [col3], [col4], [col5]]);
                        col1 = undefined;
                        col2 = undefined;
                        col3 = undefined;
                        col4 = undefined;
                        col5 = undefined;
                      });
                    } else {
                      col4 = val2[key3];
                      this.documentData.push([[col1], [col2], [col3], [col4]]);
                      col1 = undefined;
                      col2 = undefined;
                      col3 = undefined;
                      col4 = undefined;
                    }
                  });
                }
              });
            });
          }
        });
      } else {
        Object.keys(this.data).forEach((key) => {
          const res = [];
          for (let i = 0; i < this.fields.length; i++) {
            res.push([this.data[key]._source[this.fields[i].name]]);
          }
          this.documentData.push(res);
        });
      }
      this.createFileExele(format);
    },
    createFileExele(format) {
      const ws = XLSX.utils.aoa_to_sheet(this.documentData);
      const wb = XLSX.utils.book_new();
      let name = this.filename || store.state.activeSidebarItem.code || "ROSSTAT"
      name = name.substr(0,31)
      XLSX.utils.book_append_sheet(wb, ws, name);
      try {
        XLSX.writeFile(wb, `${name}.${format}`)
      } catch (err) {
        this.$notification.error({
            message: `Не удалось скачать данные. Обратитесь к администратору.`,
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.elastic-block {
  &__list-exports {
    display: flex;
    flex-direction: column;
  }

  &__btn-export {
    text-align: left;
  }
}
</style>
